<template>
    <div>
      <div class="vx-card p-6" style="margin-bottom:10px">
      <div class="vx-row">
        <div class="vx-col w-full">
          <h3>Tin cảnh báo</h3>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col mt-2" style="width:80%; text-align:right">
            <span style="float:left; font-size:15px;font-weight:bold">Có 5 nôi dung</span>
            <span class="title">Hiển thị:</span>
            <feather-icon
             icon="GridIcon"
             class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer view"
             @click="currentViews ='grid-item'"
             :svgClasses="{'text-primary stroke-current': currentViews == 'grid-item'}"></feather-icon>
            <feather-icon
            icon="ListIcon"
            class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer view"
            @click="currentViews = 'list-item'"
            :svgClasses="{'text-primary stroke-current': currentViews == 'list-item'}"
            ></feather-icon>
        </div>
        <div class="vx-col mt-2" style="width:20%;text-align:right;padding-top:17px">
          <span class="title">Sắp xếp: </span>
           <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                            <span>{{valueText}}</span>
                            <feather-icon icon ="ChevronDownIcon" style="vertical-align:middle"> </feather-icon>
                            <vs-dropdown-menu class="vx-navbar-dropdown" style="width:200px;">
                            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="clickNewPost">
                              <feather-icon icon="ArrowUpIcon" svgClasses="w-4 h-4" />
                              <span class="ml-2" style="vertical-align:middle">Mới nhất</span>
                            </li>

                             <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="clickNewPost">
                              <feather-icon icon="ArrowDownIcon" svgClasses="w-4 h-4" />
                              <span class="ml-2" style="vertical-align:middle">Cũ nhất</span>
                            </li>
                            </vs-dropdown-menu>
                  </vs-dropdown>
        </div>
      </div>
    </div>

    <!-- Grid-view -->
    <div class="vx-row" v-if="currentViews == 'grid-item'">
      <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base" v-for="(item,index) in dataRow" :key="index">
        <vx-card class="card">
            <feather-icon icon="FacebookIcon" class="p-2 shadow-drop rounded-lg d-theme-dark-bg facebook-icon"></feather-icon>
                  <span class="facebook-name"><b>{{item.name}}</b></span>
                  <span class="titlePost">đăng status</span>
                  <div class="">
                    <span style="font-size:10px">30/10/2020 10:30</span>
                  </div>
                  <div class="vx-row comment cursor-pointer" @click="openDialog(item)">
                    <div style="width:20%px;float:left">
                      <img data-v-3e4a5c2c="" src="https://cdn-demo.algolia.com/bestbuy-0118/6443034_sb.jpg" alt="Apple - MacBook Air® (Latest Model) - 13.3&quot; Display - Intel Core i5 - 8GB Memory - 128GB Flash Storage - Silver" style="width:100px">

                    </div>
                    <div style="width:78%; margin-left:1%; margin-top:1%" class="text">
                        <h6 data-v-3e4a5c2c="" class="item-name font-semibold mb-1 hover:text-primary cursor-pointer">
                          Apple - MacBook Air® (Latest Model) - 13.3" Display - Intel Core i5 - 8GB Memory - 128GB Flash Storage - Silver</h6>
                            <p data-v-3e4a5c2c="" class="text-sm mb-4">By
                              <span data-v-3e4a5c2c="" class="font-semibold cursor-pointer">Apple</span>
                            </p>
                              <p data-v-3e4a5c2c="" class="item-description text-sm">MacBook Air features up to 8GB of memory, a fifth-generation Intel Core processor, Thunderbolt 2, great built-in apps, and all-day battery life.1 Its thin, light, and durable enough to take everywhere you go-and powerful enough to do everything once you get there, better.
                              </p>

                    </div>
                  </div>
                  <div class="like">
                    <span>{{totalPages}} like </span>
                    <span>{{pageNumbers}} comment </span>
                    <span>{{currentPage}} share</span>
                  </div>
                    <div class="flex justify-between flex-wrap dropDownBorder">
                      <div class="vx-col md:w-1/2 w-full mt-2 cartPost">

                      </div>

                      <div v-if="bookmark" class="vx-col md:w-1/6 w-full mt-2 marginLeft" title="Lưu lại tin" style="width:20px">
                      <feather-icon icon="BookmarkIcon" @click="changeStar"></feather-icon>
                      </div>

                      <div v-if="star" class="vx-col md:w-1/6 w-full mt-2 marginLeft" title="Lưu lại tin" style="width:20px">
                      <feather-icon icon="StarIcon" @click="changeBookmark"></feather-icon>
                      </div>

                      <div class="vx-col md:w-1/6 w-full mt-2 marginLeft">
                        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" title="Đánh dấu sắc thái">
                          <feather-icon :icon = "radio" style="width:20px; color: red"> </feather-icon>
                          <vs-dropdown-menu class="vx-navbar-dropdown" style="text-align:center;">
                          <div>
                            <vs-radio vs-value ="SmileIcon" v-model="radio">
                            <feather-icon icon = "SmileIcon" style="width: 20px; color:green;vertical-align:middle" ></feather-icon>
                            <span> Tích cực</span></vs-radio>
                          </div>
                          <div class="radio-margin-bottom-border">
                            <vs-radio vs-value ="FrownIcon" v-model="radio">
                            <feather-icon icon = "FrownIcon" style="width: 20px; color:red;vertical-align:middle"></feather-icon> Tiêu cực</vs-radio>
                          </div>
                          <div class="radio-margin-bottom-border" style="margin-left:4px">
                            <vs-radio vs-value ="MehIcon" v-model="radio">
                            <feather-icon icon = "MehIcon" style="width: 20px;vertical-align:middle"> </feather-icon> Trung lập</vs-radio>
                          </div>
                          </vs-dropdown-menu>
                        </vs-dropdown>
                      </div>

                      <div class="vx-col md:w-1/6 w-full mt-2 marginLeft">
                        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                            <feather-icon icon ="MoreHorizontalIcon" style="width:20px"> </feather-icon>
                            <vs-dropdown-menu class="vx-navbar-dropdown">
                            <vs-dropdown-item>
                              <div class="cursor-pointer" @click="reportSpamForm">
                                <feather-icon icon ="FlagIcon" style="margin-right:5px"> </feather-icon>
                                <span>Đánh dấu tin rác</span>
                              </div>
                            </vs-dropdown-item>
                            </vs-dropdown-menu>
                          </vs-dropdown>
                      </div>
                    </div>
        </vx-card>
      </div>
      </div>


      <!-- List-view -->
      <div class="vx-row" v-if="currentViews =='list-item'">
          <div class="vx-col w-full" v-for="(item,index) in dataRow" :key="index">
                <vx-card class="card"  style="border:1px solid #ff000042; margin-bottom:10px" >
                  <feather-icon icon="FacebookIcon" class="p-2 shadow-drop rounded-lg d-theme-dark-bg facebook-icon"></feather-icon>
                  <span class="facebook-name"><b>{{item.name}}</b></span>
                  <span class="titlePost">đăng status</span>
                  <div class="">
                    <span style="font-size:10px">30/10/2020 10:30</span>
                  </div>
                  <div class="vx-row comment cursor-pointer"  @click="openDialog(item)">
                    <div style="width:20%px;float:left">
                      <img data-v-3e4a5c2c="" src="https://cdn-demo.algolia.com/bestbuy-0118/6443034_sb.jpg" alt="Apple - MacBook Air® (Latest Model) - 13.3&quot; Display - Intel Core i5 - 8GB Memory - 128GB Flash Storage - Silver" style="width:100%">

                    </div>
                    <div style="width:78%; margin-left:1%;margin-top:1%" class="text">
                        <h6 data-v-3e4a5c2c="" class="item-name font-semibold mb-1 hover:text-primary cursor-pointer">
                          Apple - MacBook Air® (Latest Model) - 13.3" Display - Intel Core i5 - 8GB Memory - 128GB Flash Storage - Silver</h6>
                            <p data-v-3e4a5c2c="" class="text-sm mb-4">By
                              <span data-v-3e4a5c2c="" class="font-semibold cursor-pointer">Apple</span>
                            </p>
                              <p data-v-3e4a5c2c="" class="item-description text-sm">MacBook Air features up to 8GB of memory, a fifth-generation Intel Core processor, Thunderbolt 2, great built-in apps, and all-day battery life.1 Its thin, light, and durable enough to take everywhere you go-and powerful enough to do everything once you get there, better.
                              </p>

                    </div>
                  </div>
                  <div class="like">
                    <span>{{totalPages}} like </span>
                    <span>{{pageNumbers}} comment </span>
                    <span>{{currentPage}} share</span>
                  </div>
                    <div class="flex justify-between flex-wrap dropDownBorder">
                      <div class="vx-col md:w-2/3"></div>

                     <div class="vx-row">
                      <div v-if="bookmark" class="vx-col md:w-1/6 w-full mt-2 down-width" title="Lưu lại tin" style="width:20px">
                      <feather-icon icon="BookmarkIcon" @click="changeStar"></feather-icon>
                      </div>

                      <div v-if="star" class="vx-col md:w-1/6 w-full mt-2 down-width" title="Lưu lại tin" style="width:20px">
                      <feather-icon icon="StarIcon" @click="changeBookmark"></feather-icon>
                      </div>

                      <div class="vx-col md:w-1/6 w-full mt-2 down-width">
                        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" title="Đánh dấu sắc thái">
                          <feather-icon :icon = "radio" style="width:20px;color:red"> </feather-icon>
                          <vs-dropdown-menu class="vx-navbar-dropdown" style="text-align:center">
                          <div  @click="getValueRadio(radio)">
                            <vs-radio vs-value ="SmileIcon" v-model="radio">
                            <feather-icon icon = "SmileIcon" style="width: 20px; color:green;vertical-align:middle" ></feather-icon>
                            <span> Tích cực</span></vs-radio>
                          </div>
                          <div class="radio-margin-bottom-border">
                            <vs-radio vs-value ="FrownIcon" v-model="radio">
                            <feather-icon icon = "FrownIcon" style="width: 20px; color:red;vertical-align:middle"></feather-icon> Tiêu cực</vs-radio>
                          </div>
                          <div class="radio-margin-bottom-border" style="margin-left:4px">
                            <vs-radio vs-value ="MehIcon" v-model="radio">
                            <feather-icon icon = "MehIcon" style="width: 20px;vertical-align:middle"> </feather-icon> Trung lập</vs-radio>
                          </div>
                          </vs-dropdown-menu>
                        </vs-dropdown>
                      </div>

                      <div class="vx-col md:w-1/12 w-full mt-2 down-width">
                        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                            <feather-icon icon ="MoreHorizontalIcon" style="width:20px"> </feather-icon>
                            <vs-dropdown-menu class="vx-navbar-dropdown" style="width:150px">
                              <vs-dropdown-item>
                                <div class="cursor-pointer" @click="reportSpamForm">
                                  <feather-icon icon ="FlagIcon" style="margin-right:5px"> </feather-icon>
                                  <span>Đánh dấu tin rác</span>
                                </div>
                              </vs-dropdown-item>
                            </vs-dropdown-menu>
                          </vs-dropdown>
                      </div>
                     </div>
                    </div>
                </vx-card>
            </div>
      </div>

      <div style="float:right">
          <vs-button icon-pack ="feather" type="border" color="warning" @click="$router.go(-1)">Quay lại</vs-button>
      </div>
    </div>
</template>
<script>
export default {
  components:{

  },
  data(){
    return{
      valueText:'Mới nhất',
      dataRow:null,
      currentViews:'grid-item',

      radio:'FrownIcon',

      bookmark:true,
      star:false,

      pageSize:5,
      totalPages:null,
      currentPage:0,
      pageNumbers:null,
      rangeDate:null

    }
  },
  async created(){
    this.getListFacebook();
  },
  methods:{
    clickNewPost: function(){
      this.valueText = 'Mới nhất';
    },
    getListFacebook: function(){
      const payload ={
        pageNumber:0,
        pageSize:5
      };
      this.$processor.post('/facebook-queue/range', payload).then((res) =>{
        this.dataRow = res.data.content;
        this.totalPages = parseInt(res.data.totalPages,10);
        this.pageNumbers = res.data.pageable.pageNumber;
        this.dataRow.forEach(el =>{
          let details = JSON.parse(el.details);
          el.name = details.name;
          el.date = el.createDate;
          let dateNow = new Date().getDate();
          let createdDate =  new Date(el.date).getDate();
          this.rangeDate = dateNow - createdDate;
        })
      })
    },
    changeStar:function(){
      this.bookmark = false;
      this.star = true;
    },
    changeBookmark:function(){
      this.bookmark = true;
      this.star = false;
    },
    reportSpamForm: function(){
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Đánh dấu tin rác`,
        text: `Bạn có chắc là tin rác`,
        accept: this.confirmDialog,
        cancel: this.confirmDialog,
        acceptText: "Xác nhận",
        cancelText: "Huỷ"
      })
    }
  }
}
</script>
<style scoped>
.view{
  vertical-align: bottom;
  margin-bottom: 3px;
  margin-left: 10px;
}
.marginLeft{
  width: 7% !important;
}
.cartPost{
  width: 60% !important;
}
.facebook-name{
  font-size: 25px;
  margin-right: 5px;
}
.facebook-icon{
  background-color: #3B5998;
  color: white;
  margin-right: 5px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  border-radius: 70%;
}
.down-width{
  width: 3% !important;
}
.like{
  font-size: 13px;
  color: #ccc;
}
.title{
  font-weight: bold;
}
.card{
  border: 1pt solid rgb(255 0 0 / 57%);
}
.vx-navbar-dropdown{
  width: 170px;
}
</style>
